var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid",staticStyle:{"background-color":"white"}},[_c('pdf-render-area',{ref:"pdfRenderAreaRef",attrs:{"base64Pdf":_vm.base64Pdf}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }